export default "__VITE_ASSET__KHbNzwhg__";